import type ThreeDSecureResponse from '../types/ThreeDSecureResponse';

export default function isThreeDSecureResponse(response: object): response is ThreeDSecureResponse {
  return 'three_d_secure_action_token_id' in response;
}
